// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE

import type { ComponentType } from 'react';
import { generateAsyncRoute } from '@thd-olt-component-react/router';
import type { LandingPageProps } from './pages/LandingPage';

type PageComponent = ComponentType<LandingPageProps>;

/* Pages imported up front for the server render; empty in the browser. */
export interface ServerPages {
  landing?: PageComponent;
}

const ssr = typeof window === 'undefined';

export const getServerPages = async (): Promise<ServerPages> => {
  const Components: ServerPages = {};
  if (ssr) {
    Components.landing = (await import('./pages/LandingPage')).LandingPage;
  }
  return Components;
};

export const getRoutes = (
  currentRouteName?: string,
  currentRouteComponent?: PageComponent,
  serverPages?: ServerPages,
) => ({
  landing: {
    name: 'LandingPage',
    componentName: 'LandingPage',
    chunk: () => import('./pages/LandingPage'),
    get component(): PageComponent | undefined {
      return ssr
        ? serverPages?.landing
        : currentRouteName === 'LandingPage'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.LandingPage,
              })),
            );
    },
    path: '/:context?/military/discount',
    prefetch: ['verification'],
    channel: null,
  },
});
